/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Flow/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoOption from './NoOption/index'
import React from 'react'
import Warning from './Warning/index'
import YesOption from './YesOption/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Flow({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/AcceptTreatmentAction/Content/FinancialsManagedExternally/Flow"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="Flow.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-9Ehc': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Flow.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<YesOption
  viewPath={`${viewPath}/YesOption`}
/>
<NoOption
  viewPath={`${viewPath}/NoOption`}
/>
</div>
<Warning
  viewPath={`${viewPath}/Warning`}
/>
</div>
{children}
</React.Fragment>)
}